import {HeaderTitle} from '../../../../common/HeaderTitle.jsx'
import {SimpleTable} from "../../../../common/simpleTable/SimpleTable.jsx";
import {tableListaKontProfilu} from "../../lib/columns/tableListaKontProfilu.jsx";
import {useKontaPowiazaneProfilu} from "../../../../../api/domain/profile/queries/useKontaPowiazaneProfilu.jsx";
import ButtonWithIcon from "../../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../../common/Icons.jsx";
import {useSelector} from "react-redux";
import {useState} from "react";
import {usePowiazKontoZProfilem} from "../../../../../api/domain/profile/mutations/usePowiazKontoZProfilem.jsx";
import {useOdlaczKontoOdProfilu} from "../../../../../api/domain/profile/mutations/useOdlaczKontoOdProfilu.jsx";
import {useParams, useNavigate} from "react-router-dom";
import {ModalOdlaczKonto, ModalPowiazKonto} from "../../lib/modals.jsx";

const ViewListaKontProfilu = () => {
    const {profilId} = useParams()
    const navigate = useNavigate()
    const rola = useSelector((state) => state.user.role)
    const currentUserId = useSelector((state) => state.user.user?.user_id ?? state.user.user?.id)
    const listaPozycji = useKontaPowiazaneProfilu(profilId)
    const powiazKonto = usePowiazKontoZProfilem()
    const odlaczKonto = useOdlaczKontoOdProfilu()
    const titleName = `Lista kont powiązanych z profilem: ${profilId || ''}`
    const [currPozycja, setCurrPozycja] = useState({})
    const [form, setForm] = useState({id: '', user_email: ''})
    const [modalState, setModalState] = useState({
        delete: false,
        powiaz: false,
    })
    const permissions = useSelector((state) => state.user.permissions)
    const canModifyProfile = Array.isArray(permissions) && permissions.includes('profile_modyfikacja')
    const canViewUsers = Array.isArray(permissions) && permissions.includes('uzytkownicy_podglad')

    if (!canViewUsers) {
        navigate(`/${rola}/profile/lista`)
        return null
    }

    const openModal = (type, data = {}) => {
        setCurrPozycja(data)
        setModalState((prev) => ({...prev, [type]: true}))
    }

    const closeModal = (type) => {
        setModalState((prev) => ({...prev, [type]: false}))
        if (type === 'powiaz') {
            setForm({id: '', user_email: ''})
        }
    }

    const canSubmitPowiazanie =
        !!form?.user_email?.trim() &&
        Number.isInteger(+form?.id) &&
        +form?.id > 0

    const handlePowiaz = async () => {
        if (!canSubmitPowiazanie) return
        await powiazKonto.mutate({
            profil_id: profilId,
            id: +form.id,
            user_email: form.user_email.trim(),
        })
        closeModal('powiaz')
    }

    const handleOdlacz = async () => {
        await odlaczKonto.mutate({
            profilId,
            userId: currPozycja.id,
        })
        closeModal('delete')
    }

    const modals = () => (
        <>
            <ModalOdlaczKonto
                show={modalState.delete}
                handleClose={() => closeModal('delete')}
                currPozycja={currPozycja}
                isPending={odlaczKonto.isPending}
                onConfirm={handleOdlacz}
            />
            <ModalPowiazKonto
                show={modalState.powiaz}
                handleClose={() => closeModal('powiaz')}
                form={form}
                setForm={setForm}
                canSubmitPowiazanie={canSubmitPowiazanie}
                isPending={powiazKonto.isPending}
                onSubmit={handlePowiaz}
            />
        </>
    )
    const th = () => (
        <>
            <th>Akcje</th>
        </>
    )

    const td = (row) => (
        <>
            <td>
                <div className={'d-flex gap-2'}>
                    {canModifyProfile && Number(row.id) !== Number(currentUserId) && (
                        <ButtonWithIcon
                            onClick={() => openModal('delete', row)}
                            variant={'danger'}
                            size={'sm'}
                            icon={<Icons.delete/>}
                            title='Odłącz konto od profilu'
                        />
                    )}
                </div>
            </td>
        </>
    )

    return (
        <>
            {Object.keys(modalState || {}).some((k) => k) && modals()}
            <HeaderTitle
                breadcrumbLinks={[
                    {label: 'Lista profili', to: `/${rola}/profile/lista`},
                    {label: titleName},
                ]}
                home
                nav
                destination={`/${rola}/profile/lista`}
                size={'fs-3'}
                title={titleName}
            />
            <div className={'d-flex justify-content-end gap-3'}>
                {canModifyProfile && (
                    <ButtonWithIcon
                        size={'lg'}
                        text={'Powiąż konto z profilem'}
                        variant={'primary'}
                        icon={<Icons.addUser/>}
                        title='Powiąż konto z profilem'
                        onClick={() => openModal('powiaz', {profilId})}
                    />
                )}
            </div>
            <SimpleTable
                detailKey={`profile_konta_polaczone_${profilId}`}
                columns={tableListaKontProfilu}
                addTh={th}
                addTd={td}
                data={listaPozycji.data || []}
            />
        </>
    )
}

export default ViewListaKontProfilu
